import { render, staticRenderFns } from "./SystemTable.vue?vue&type=template&id=f2a0ffe2&"
import script from "./SystemTable.vue?vue&type=script&lang=js&"
export * from "./SystemTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports